/**
 * @file dbUtilities.js
 * @description client-side database utilities
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 *  * https://www.npmjs.com/package/bson-objectid
 * 
 * @author don michael
 * @since Jul 15, 2019 16:20
 */

import ObjectId from 'bson-objectid';

/**
 * returns a mongoDb ObjectId as a string
 */
export function createId() {
    const id = new ObjectId();
    return id.toHexString();
}